/**
 * Documentation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track
 */
export function trackEventViaSegment (name, data) {
  if (window.analytics && typeof window.analytics.track === 'function') {
    try {
      window.analytics.track(name, data)
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track event via Segment', e)
    }
  }
}

/**
 * Documentation: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#page
 */
export function trackPageViaSegment (pageName, data) {
  if (window.analytics && typeof window.analytics.page === 'function') {
    try {
      window.analytics.page(pageName, _.omit(data, ['name']))
    } catch (e) {
      // eslint-disable-next-line no-undef
      Rollbar.error('Failed to track page view via Segment', e)
    }
  }
}
